import { type FC, useEffect, useMemo } from 'react'
import { useLocation } from 'react-router'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  ConversationNewSearchContext,
  useConversationNewSearchContext,
} from 'widgets/ConversationNew/context/conversationNewSearchContext'
import { type ConversationNewSearchStore } from 'widgets/ConversationNew/store/conversationNewSearchStore'
import styles from 'widgets/ConversationNew/ui/styles.module.scss'
import { ConversationSearchHeader } from 'widgets/ConversationNew/ui/ConversationSearchHeader/ConversationSearchHeader'
import { ConversationChooseNumber } from 'widgets/ConversationNew/ui/ConversationChooseNumber/ConversationChooseNumber'

const ConversationNewContent = observer(() => {
  const { conversationStore } = useEntitiesContext()
  const store = useConversationNewSearchContext()
  const { state } = useLocation()
  const inboxId = state?.inboxId as number | undefined
  const numberId = state?.numberId as number | undefined
  const contact = store.items.length ? store.items[0] : undefined

  useEffect(() => {
    store.init()
    store.setVisibleUI(true)
    store.reactionDropDownOpen()
    store.reactionInbox()
    store.reactionItems()
    store.initInbox(inboxId)
    if (typeof numberId === 'number' && typeof inboxId === 'number')
      store.sendFromStore.setSelectItem({ inbox_id: inboxId, number_id: numberId })
    if (!conversationStore.currentItem?.isNew) conversationStore.createNewConversation(contact)

    return () => {
      store.setVisibleUI(false)
      store.reset()
      store.clearReactions()
      conversationStore.deleteItem(0)
    }
  }, [])

  useEffect(() => {
    store.loadMessages()
  }, [store.activeInboxId, store.items.length])

  return useMemo(
    () => (
      <div className={styles.wrap}>
        <ConversationSearchHeader />
        <ConversationChooseNumber sendFromStore={store.sendFromStore} />
      </div>
    ),
    []
  )
})

type IConversationNewProps = {
  store: ConversationNewSearchStore
}

export const ConversationNew: FC<IConversationNewProps> = observer(({ store }) => {
  return useMemo(
    () => (
      <ConversationNewSearchContext.Provider value={store}>
        <ConversationNewContent />
      </ConversationNewSearchContext.Provider>
    ),
    []
  )
})
